import React from "react";
import Header from "./Header";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";

const Layout = () => {
  return (
    <div className="main-container">
      <div className="header-outer">
        <Header />
      </div>
      <Outlet />
      <div className="footer-outer">
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
